import { useState } from 'react';
import { X } from 'lucide-react';
import { T, RADIUS, SHADOW } from '@/lib/tokens';
import { ADD_ITEMS_NUDGE_KEY } from '@/lib/constants';

interface AddItemsNudgeBannerProps {
  onAddItem: () => void;
  userItemCount: number;
  userId: string;
}

/**
 *
 * @param root0
 * @param root0.onAddItem
 * @param root0.userItemCount
 */
export function AddItemsNudgeBanner({ onAddItem, userItemCount, userId }: AddItemsNudgeBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (userItemCount > 0) return null;

  const storageKey = `${ADD_ITEMS_NUDGE_KEY}_${userId}`;
  const dismissCount = parseInt(localStorage.getItem(storageKey) || '0', 10);
  if (dismissCount >= 3) return null;
  if (dismissed) return null;

  const handleDismiss = () => {
    const newCount = dismissCount + 1;
    localStorage.setItem(storageKey, String(newCount));
    setDismissed(true);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 14px',
        background: T.accentSoft,
        border: `1px solid ${T.accentBorder}`,
        borderRadius: RADIUS.lg,
        marginBottom: 12,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 13, color: T.text, margin: '0 0 2px', lineHeight: 1.5, fontWeight: 600 }}>
          You're part of the group — share something back!
        </p>
        <p style={{ fontSize: 12, color: T.textMuted, margin: 0, lineHeight: 1.4 }}>
          Tools, books, board games, puzzles...
        </p>
      </div>
      <button
        onClick={onAddItem}
        style={{
          padding: '7px 14px',
          borderRadius: RADIUS.sm,
          background: T.accent,
          color: T.white,
          border: 'none',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
          boxShadow: SHADOW.btn.accent,
        }}
      >
        Add Item
      </button>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: T.textMuted,
          padding: 4,
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
